export class DropdownOption {
  value: any;
  text: string;

  constructor(value: any, text: string) {
    this.value = value;
    this.text = text;
  }
}
